import React from "react";

// Geometric mountain peak that doubles as a building silhouette
export const LogoMark = ({ className = "", color = "currentColor" }) => (
  <svg viewBox="0 0 48 40" fill="none" className={className} aria-hidden="true">
    <path d="M24 2 L46 38 H30 L24 24 L18 38 H2 Z" fill={color} opacity="0.9" />
    <path d="M24 2 L32 15 H16 Z" fill={color} />
    <rect x="21" y="18" width="6" height="20" fill={color} />
    <rect x="22.2" y="21" width="1.4" height="2.4" fill="#fff" opacity="0.55" />
    <rect x="24.4" y="21" width="1.4" height="2.4" fill="#fff" opacity="0.55" />
    <rect x="22.2" y="25" width="1.4" height="2.4" fill="#fff" opacity="0.55" />
    <rect x="24.4" y="25" width="1.4" height="2.4" fill="#fff" opacity="0.55" />
  </svg>
);

export const LogoLockup = ({ dark = true, className = "" }) => (
  <img
    src={dark ? "/logo-white.png" : "/logo-navy.png"}
    alt="North Peak Facility Services"
    className={`h-12 md:h-14 w-auto object-contain select-none ${className}`}
    draggable="false"
  />
);
